class PreLaunchReviews extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    const swiperContainer = this.querySelector(".pre-launch-reviews__reviews");
    if (!swiperContainer) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    this.swiper = new Swiper(swiperContainer, {
      observer: true,
      observeParents: true,
      centeredSlides: true,
      slidesPerView: 1,
      loop: true,
      spaceBetween: 10,
      slideToClickedSlide: true,
      autoplay: {
        delay: 6000,
      },
      pagination: {
        el: ".pre-launch-reviews .swiper-pagination",
        type: "bullets",
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
        },
      },
      on: {
        init: () => {
          setTimeout(() => this.equalizeSlideHeights(), 0);
        },
      },
    });

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  equalizeSlideHeights() {
    if (!this.swiper) return;

    let maxHeight = 0;
    const slides = this.swiper.slides;

    slides.forEach((slide) => {
      slide.style.height = "";
      const contentElement = slide.querySelector(
        ".pre-launch-reviews__review-card-content"
      );
      if (contentElement) {
        const height = contentElement.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      }
    });

    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
    });

    this.swiper.update();
  }

  handleResize() {
    this.debounce(() => {
      this.equalizeSlideHeights();
    }, 500)();
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define("pre-launch-reviews", PreLaunchReviews);

// Shopify Theme Editor Events
document.addEventListener("shopify:section:load", function (event) {
  if (event.target.classList.contains("pre-launch-reviews")) {
    event.target.initSwiper();
  }
});

document.addEventListener("shopify:section:unload", function (event) {
  if (event.target.classList.contains("pre-launch-reviews")) {
    event.target.disconnectedCallback();
  }
});

document.addEventListener("shopify:block:select", function (event) {
  const section = event.target.closest("pre-launch-reviews");
  if (section && section.swiper) {
    const slideIndex = Array.from(section.swiper.slides).findIndex((slide) =>
      slide.contains(event.target)
    );
    if (slideIndex !== -1) {
      section.swiper.slideToLoop(slideIndex);
    }
  }
});
